import React from 'react';

function TextNormal(props) {

    return(
        <p>{props.text}</p>
    );
}

export default TextNormal;